// svg polyfill for better use element support
require('svgxuse');

// track input methods for styling
require('what-input');

// automatically require all modules
require('./modules/_gallery.js');require('./modules/_header.js');
